import { Col, Form, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../Buttons/Buttons";
import Select from 'react-select';
import attachmentImg from '../../assets/images/attachmentImg.svg';
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadBranchDropdownData, loadBusinessUnitDropdownData, loadCompanyDropdownData, loadIssueTypeDropdownData, loadReportingToDropdownData, loadUserSlocsDropdownData, postComplaintEscalationDatas } from "../../redux/action";
import { ADDED_BY_ID, Company_ID } from "../../Constants";
import * as HeaderAuthentication from '../HeaderAuthentication';
import { baseURL } from "../BaseUrl";

const statusOptions = [
    { value: 36, label: "Pending" },
    { value: 37, label: "In-Process" },
    { value: 38, label: "Resolved" },
    { value: 39, label: "Re-Open" },
    { value: 40, label: "Cancel" },
]

const ticketTypeOptions = [
    // { value: "Complaint Ticket", label: "Service Request" },
    // { value: "Escalation Ticket", label: "Service Request Escalated" }
    { value: "Service Request", label: "Service Request" },
    { value: "Service Request Escalated", label: "Service Request Escalated" }
]

const priorityOptions = [
    { value: "Low", label: "Low" },
    { value: "Medium", label: "Medium" },
    { value: "High", label: "High" },
]

const options = [
    { value: "Plant", label: "Plant" },
    { value: "Business Unit", label: "Business Unit" },
]

const AddComplaintEscalation = (props) => {

    let dispatch = useDispatch();
    const getComplaintData = props.getComplaintData;
    const singleComplaintEscalationData = props.singleComplaintEscalationData;

    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const email = signInDetails ? signInDetails[0].EmailID : null;
    const userName = signInDetails ? signInDetails[0].UserName : null;
    const mobile = signInDetails ? signInDetails[0].Mobile : null;
    const zipCode = signInDetails ? signInDetails[0].ZipCode : null;
    const address = signInDetails ? signInDetails[0].Address : null;
    const companyName = signInDetails ? signInDetails[0].CompanyName : null;

    const complaintId = props.complaintId;
    const { reportingToDropdown } = useSelector((state) => state.data);
    const { branchDropdown } = useSelector((state) => state.data);
    const { businessUnitDropdown } = useSelector((state) => state.data);
    const { issueTypeDropdownData } = useSelector((state) => state.data);
    const { getCompanyDropdown } = useSelector((state) => state.data);
    const { userSlocsDropdown } = useSelector((state) => state.data);

    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedType, setSelectedType] = useState("");
    const fileInputRef = useRef(null);
    const [complaintData, setComplaintData] = useState({
        ComplaintID: null,
        TicketType: "",
        CompanyID: null,
        ReportedByUserID: null,
        BranchID: null,
        Priority: "",
        IssueTypeID: null,
        Email: email,
        ContactNo: mobile,
        ZIPCode: zipCode,
        Address: address,
        AssignedToUserID: null,
        TATInDays: null,
        UserUploadedFileName: null,
        TempFileName: null,
        Remarks: "",
        StatusID: null,
        AddedByID: ADDED_BY_ID,
        SignInType: signInDetails[0].SignInType
    });

    const [errors, setErrors] = useState({}); // Error state to store validation errors

    // Handle file selection and upload
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file); // Store the selected file in the state
            // Update complaint data with file name
            setComplaintData(prevData => ({
                ...prevData,
                UserUploadedFileName: file.name,
                // TempFileName: file.name 
            }));

            // File upload API call
            uploadFile(file);
        }
    };

    // Trigger file input click
    const handleAttachmentClick = () => {
        fileInputRef.current.click();
    };

    useEffect(() => {
        let reportedByUserId = null; // Declare companyId variable outside the condition.
        let comapanyId = null;

        if (signInDetails && signInDetails[0]) {
            const signInType = signInDetails[0].SignInType; // Ensure signInType is defined

            // Assign companyId based on SignInType
            if (signInType === "SuperAdmin") {
                reportedByUserId = signInDetails[0].SuperAdminID; // Set SuperAdminID as companyId
            } else if (signInType === "ClientAdmin") {
                reportedByUserId = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
            } else if (signInType === "User") {
                reportedByUserId = signInDetails[0].UserID; // Use UserID for User
            }
        }
        if (signInDetails && signInDetails[0]) {
            const signInType = signInDetails[0].SignInType; // Ensure signInType is defined

            // Assign companyId based on SignInType
            if (signInType === "SuperAdmin") {
                comapanyId = signInDetails[0].SuperAdminID; // Set SuperAdminID as companyId
            } else if (signInType === "ClientAdmin") {
                comapanyId = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin
            } else if (signInType === "User") {
                comapanyId = signInDetails[0].CompanyID; // Use UserID for User
            }
        }

        // Update the state or perform further actions with companyId
        setComplaintData(prevData => ({
            ...prevData,
            ReportedByUserID: reportedByUserId,
            CompanyID: comapanyId,
        }));
    }, []); // Dependencies array to re-run the effect when signInDetails change

    // Effect hook for loading dropdown data
    useEffect(() => {
        // dispatch(loadReportingToDropdownData());
        // dispatch(loadBranchDropdownData());
        dispatch(loadIssueTypeDropdownData());
        dispatch(loadCompanyDropdownData());
    }, [dispatch]);

    useEffect(() => {
        dispatch(loadUserSlocsDropdownData());
    }, [])

    useEffect(() => {
        setComplaintData(prevData => ({
            ...prevData,
            CompanyID: Company_ID ? Company_ID : complaintData.CompanyID
        }));
    }, [Company_ID])

    useEffect(() => {
        if (complaintData.CompanyID) {
            dispatch(loadBranchDropdownData(complaintData.CompanyID));
            dispatch(loadBusinessUnitDropdownData(complaintData.CompanyID));
            dispatch(loadReportingToDropdownData(complaintData.CompanyID));
        }
    }, [complaintData.CompanyID, dispatch])

    useEffect(() => {
        if (selectedType) {
            const companyID = complaintData.CompanyID || Company_ID; // Use session ID or complaintData ID

            if (selectedType === "Plant") {
                dispatch(loadBranchDropdownData(companyID));
            } else if (selectedType === "Business Unit") {
                dispatch(loadBusinessUnitDropdownData(companyID));
            }
        }
    }, [selectedType, complaintData.CompanyID]); // Ensure re-fetching if CompanyID changes

    useEffect(() => {
        // Declare local variables to hold companyId and reportedByUserId
        let companyId = null;
        let reportedByUserId = null;

        // Check if signInDetails are available
        if (signInDetails && signInDetails[0]) {
            const signInType = signInDetails[0].SignInType;

            // Set companyId and reportedByUserId based on SignInType
            if (signInType === "SuperAdmin") {
                companyId = signInDetails[0].SuperAdminID;
                reportedByUserId = signInDetails[0].SuperAdminID;
            } else if (signInType === "ClientAdmin") {
                companyId = signInDetails[0].CompanyID;
                reportedByUserId = signInDetails[0].CompanyID;
            } else if (signInType === "User") {
                companyId = signInDetails[0].CompanyID;
                reportedByUserId = signInDetails[0].UserID;
            }
        }

        // Check if there is valid complaint data
        if (complaintId && singleComplaintEscalationData && singleComplaintEscalationData.length > 0) {
            const complaint = singleComplaintEscalationData[0];

            // Set the complaint data to populate the form with values from singleComplaintEscalationData
            setComplaintData({
                ComplaintID: complaintId,
                TicketType: complaint.TicketType || "",
                CompanyID: complaint.CompanyID || companyId || null,  // Ensure CompanyID is assigned correctly
                ReportedByUserID: complaint.ReportedByUserID || reportedByUserId || null, // Ensure ReportedByUserID is assigned correctly
                BranchID: complaint.BranchID || null,
                Priority: complaint.Priority || "",
                IssueTypeID: complaint.IssueTypeID || null,
                Email: complaint.Email || signInDetails?.[0]?.EmailID || "",
                ContactNo: complaint.ContactNo || signInDetails?.[0]?.Mobile || "",
                ZIPCode: complaint.ZIPCode || signInDetails?.[0]?.ZipCode || "",
                Address: complaint.Address || signInDetails?.[0]?.Address || "",
                AssignedToUserID: complaint.AssignedToUserID || null,
                TATInDays: complaint.TATInDays || null,
                UserUploadedFileName: complaint.AttachedFileName || null,
                TempFileName: complaint.AttachedFileName || null,
                Remarks: complaint.Remarks || "",
                StatusID: complaint.StatusID || null,
                AddedByID: ADDED_BY_ID,
                SignInType: signInDetails[0].SignInType
            });
            // Automatically determine if it's Plant or Business Unit
            if (complaint.BranchID) {
                if (branchDropdown.some(option => option.value === complaint.BranchID)) {
                    setSelectedType("Plant");
                } else if (businessUnitDropdown.some(option => option.value === complaint.BranchID)) {
                    setSelectedType("Business Unit");
                }
            }
        }

    }, [complaintId, singleComplaintEscalationData]);


    // File upload function
    const uploadFile = (file) => {
        const formData = new FormData();
        formData.append("file", file); // Attach the selected file to the form data

        fetch(`${baseURL}/complaintservices/api/Complaint/UploadFile`, {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.excomatixAuth,
            body: formData,
        })
            .then((resp) => resp.json())
            .then((resp) => {
                //  update the TempFileName from response
                setComplaintData(prevData => ({
                    ...prevData,
                    TempFileName: resp // Update with the TempFileName from the response
                }));
            })
            .catch((err) => {
                console.error("File upload failed:", err);
            });
    };

    // Validate form fields
    const validateForm = () => {
        const newErrors = {};
        if (!complaintData.TicketType) newErrors.TicketType = "Ticket Type is required.";
        // if (!complaintData.CompanyID) newErrors.CompanyID = "Company Name is required.";
        // if (!complaintData.ReportedByUserID) newErrors.ReportedByUserID = "Reported By is required.";
        // if (!complaintData.BranchID) newErrors.BranchID = "Branch is required.";
        // if (!complaintData.Priority) newErrors.Priority = "Priority is required.";
        if (!complaintData.IssueTypeID) newErrors.IssueTypeID = "Issue Type is required.";
        // if (!complaintData.Email) newErrors.Email = "Email is required.";
        // if (!complaintData.ContactNo) newErrors.ContactNo = "Contact is required.";
        // if (!complaintData.ZIPCode) newErrors.ZIPCode = "Zip Code is required.";
        // if (!complaintData.Address) newErrors.Address = "Address is required.";
        // if (!complaintData.AssignedToUserID) newErrors.AssignedToUserID = "Assigned To is required.";
        // if (!complaintData.TATInDays) newErrors.TATInDays = "TAT (Days) is required.";
        if (!complaintData.Remarks) newErrors.Remarks = "Remarks is required.";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Handle form submission (add complaint escalation data)
    const addComplaintEscalationData = (e) => {
        e.preventDefault();
        if (validateForm()) {
            let requestOption = {
                method: "POST",
                mode: "cors",
                headers: HeaderAuthentication.postExcomatixAuth,
                body: JSON.stringify(complaintData),
            };
            dispatch(postComplaintEscalationDatas(requestOption, props.handleCloseModal, getComplaintData, complaintId));
            // console.log(complaintData, 'complaintData');
        }
    }

    // Clear error for specific field
    const clearError = (field) => {
        setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            delete newErrors[field];
            return newErrors;
        });
    };

    return (
        <Modal show={props.open} onHide={props.handleCloseModal} className='add-customer-modal add-user-modal'>
            <Modal.Header closeButton>
                <Modal.Title>{complaintId ? "Edit Service Request" : "Add Service Request"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className='customer-form-fields'>
                    <Col>
                        <Row>
                            <Col md={4}>
                                <div>
                                    <label>Ticket Type <span className="required-asterisk">*</span></label>
                                    <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        options={ticketTypeOptions}
                                        value={ticketTypeOptions.find(option => option.value === complaintData.TicketType)}
                                        // onChange={(selectedOption) => setComplaintData(prevData => ({ ...prevData, TicketType: selectedOption.value }))}
                                        onChange={(selectedOption) => {
                                            setComplaintData(prevData => ({ ...prevData, TicketType: selectedOption.value }));
                                            clearError("TicketType");
                                        }}
                                        placeholder="Select"
                                        menuPosition="fixed"
                                        menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                    />
                                </div>
                                {errors.TicketType && <small className="text-danger">{errors.TicketType}</small>}
                            </Col>
                            <Col md={4}>
                                <div>
                                    <label>Company Name </label>
                                    <Form.Control
                                        type="text"
                                        // value={singleComplaintEscalationData[0]?.CompanyName || companyName || null}  // Prefill with Company Name from session
                                        value={
                                            complaintId && singleComplaintEscalationData?.length > 0
                                                ? singleComplaintEscalationData[0]?.CompanyName
                                                : companyName || ""
                                        }
                                        // value={complaintData.CompanyID || ""}
                                        disabled={true}  // Set to true to disable manual editing
                                    />
                                </div>
                                {/* {errors.CompanyID && <small className="text-danger">{errors.CompanyID}</small>} */}
                            </Col>
                            <Col md={4}>
                                <div>
                                    <label>Reported By</label>
                                    <Form.Control
                                        type="text"
                                        // value={singleComplaintEscalationData[0]?.ReportedByUser || userName || null}  // Prefill with UserName from session
                                        value={
                                            complaintId && singleComplaintEscalationData?.length > 0
                                                ? singleComplaintEscalationData[0]?.ReportedByUser
                                                : userName || ""
                                        }
                                        // value={complaintData.ReportedByUserID || ""}
                                        disabled={true}  // Disable editing for this field
                                    />
                                </div>
                                {/* {errors.ReportedByUserID && <small className="text-danger">{errors.ReportedByUserID}</small>} */}
                            </Col>
                        </Row>

                        <Row>
                            <Col md={4}>
                                <div>
                                    <label>Email </label>
                                    <Form.Control
                                        type="email"
                                        // value={email} // Prefilled with session email
                                        value={complaintData.Email || ""}
                                        disabled={true}  // Disable editing
                                    />
                                </div>
                                {/* {errors.Email && <small className="text-danger">{errors.Email}</small>} */}
                            </Col>
                            <Col md={4}>
                                <div>
                                    <label>Contact</label>
                                    <Form.Control
                                        type="tel"
                                        // value={mobile} // Prefilled with session Mobile
                                        value={complaintData.ContactNo || ""}
                                        disabled={true}  // Disable editing
                                    />
                                </div>
                                {/* {errors.ContactNo && <small className="text-danger">{errors.ContactNo}</small>} */}
                            </Col>
                            <Col md={4}>
                                <div>
                                    <label>Zip Code</label>
                                    <Form.Control
                                        type="number"
                                        // value={zipCode} // Prefilled with session ZipCode
                                        value={complaintData.ZIPCode || ""}
                                        disabled={true}  // Disable editing
                                    />
                                </div>
                                {/* {errors.ZIPCode && <small className="text-danger">{errors.ZIPCode}</small>} */}
                            </Col>
                        </Row>

                        <Row>
                            <Col md={12}>
                                <div>
                                    <label>Address </label>
                                    <Form.Control
                                        type="text"
                                        // value={address} // Prefilled with session Address
                                        value={complaintData.Address || ""}
                                        disabled={true}  // Disable editing
                                    />
                                </div>
                                {/* {errors.Address && <small className="text-danger">{errors.Address}</small>} */}
                            </Col>

                        </Row>
                        <Row>
                            <Col md={4}>
                                <div>
                                    <label>Issue Type <span className="required-asterisk">*</span></label>
                                    <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        value={issueTypeDropdownData.find(option => option.value === complaintData.IssueTypeID)}
                                        // onChange={(selectedOption) => setComplaintData(prevData => ({ ...prevData, IssueTypeID: selectedOption.value }))}
                                        onChange={(selectedOption) => {
                                            setComplaintData(prevData => ({ ...prevData, IssueTypeID: selectedOption.value }));
                                            clearError("IssueTypeID");
                                        }}
                                        options={issueTypeDropdownData}
                                        placeholder="Select"
                                        menuPosition="fixed"
                                        menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                    />
                                </div>
                                {errors.IssueTypeID && <small className="text-danger">{errors.IssueTypeID}</small>}
                            </Col>
                            <Col md={4}>
                                <div>
                                    <label>Plant</label>
                                    <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        // value={branchDropdown.find(option => option.value === complaintData.BranchID)}
                                        // onChange={(selectedOption) => {
                                        //     setComplaintData(prevData => ({ ...prevData, BranchID: selectedOption.value }));
                                        //     clearError("BranchID");
                                        // }}
                                        // options={branchDropdown}
                                        value={
                                            signInDetails[0]?.SignInType === "User"
                                                ? userSlocsDropdown.find(option => option.value === complaintData.BranchID)
                                                : branchDropdown.find(option => option.value === complaintData.BranchID)
                                        }
                                        onChange={(selectedOption) => {
                                            setComplaintData(prevData => ({ ...prevData, BranchID: selectedOption.value }));
                                            clearError("BranchID");
                                        }}
                                        options={signInDetails[0]?.SignInType === "User" ? userSlocsDropdown : branchDropdown}
                                        placeholder="Select"
                                    />
                                </div>
                            </Col>
                            {/* <Col md={4}>
                                <div>
                                    <label>Select Plant/Business Unit</label>
                                    <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        value={options.find(option => option.value === selectedType)}
                                        onChange={(selectedOption) => {
                                            setSelectedType(selectedOption.value);
                                            setComplaintData(prevData => ({ ...prevData, BranchID: "" })); // Reset branch selection
                                            clearError("BranchID");
                                        }}
                                        options={options}
                                        placeholder="Select"
                                        menuPosition="fixed"
                                        menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                    />
                                </div>
                            </Col> */}

                            {/* {selectedType && (selectedType === "Plant" || selectedType === "Business Unit") && (
                                <Col md={4}>
                                    <div>
                                        <label>{selectedType === "Plant" ? "Plant" : "Business Unit"}</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            value={(selectedType === "Plant" ? branchDropdown : businessUnitDropdown).find(option => option.value === complaintData.BranchID)}
                                            onChange={(selectedOption) => {
                                                setComplaintData(prevData => ({ ...prevData, BranchID: selectedOption.value }));
                                                clearError("BranchID");
                                            }}
                                            options={selectedType === "Plant" ? branchDropdown : businessUnitDropdown}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                            )} */}
                        </Row>
                        <Row>
                            <Col md={5} className="d-flex justify-content-start align-items-end">
                                <div className="dropdown add-single-bulk attachment-section">
                                    {/* <label>&nbsp;</label> */}
                                    <button
                                        className="btn btn-add-save-update attachment-btn"
                                        id="adduser-single-blulk"
                                        onClick={handleAttachmentClick}
                                    >
                                        <img src={attachmentImg} alt="" />&nbsp;&nbsp;
                                        <span>Attachment</span>
                                        <div className="attachment-note">
                                            <small>(jpg, PDF, word doc) Less than 5MB</small>
                                        </div>
                                    </button>
                                    <input
                                        type="file"
                                        ref={fileInputRef}
                                        style={{ display: 'none' }}
                                        onChange={handleFileChange}
                                    />
                                    {selectedFile && <div className="attachment-note"><small>{selectedFile.name}</small></div>}
                                </div>
                            </Col>
                            <Col md={7}>
                                <div>
                                    <label className="pt-2 pb-2">Remarks <span className="required-asterisk">*</span></label>
                                    <Form.Control
                                        as="textarea" // Change input type to textarea
                                        rows={2} // Set the number of visible rows
                                        value={complaintData.Remarks}
                                        // onChange={(e) => setComplaintData({ ...complaintData, Remarks: e.target.value })}
                                        onChange={(e) => {
                                            const remarks = e.target.value;
                                            setComplaintData(prevData => ({ ...prevData, Remarks: remarks }));

                                            // Clear the remarks error when the user starts typing
                                            if (errors.Remarks) {
                                                clearError("Remarks");
                                            }
                                        }}
                                    />
                                </div>
                                {errors.Remarks && <small className="text-danger">{errors.Remarks}</small>}
                            </Col>
                            {/* {complaintId && <Col md={4}>
                                <div>
                                    <label>Status</label>
                                    <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        value={statusOptions.find(option => option.value === complaintData.StatusID)}
                                        onChange={(selectedOption) => setComplaintData(prevData => ({ ...prevData, StatusID: selectedOption.value }))}
                                        options={statusOptions}
                                        placeholder="Select"
                                    />
                                </div>
                            </Col>} */}

                        </Row>
                    </Col>
                </Row>
            </Modal.Body >
            <Modal.Footer>
                <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseModal} />
                {(!complaintId || singleComplaintEscalationData[0]?.StatusID === 39) && <SBSaveUpdateBtn btnName="Submit" onClickEffect={addComplaintEscalationData} />}
            </Modal.Footer>
        </Modal >
    );
}

export default AddComplaintEscalation;

